/**
* @ngdoc directive
* @name Sticky Top Block
*
* @deprecated
*
* @description Use "sticky" instead
*
*/
app.directive('stickyTopBlock', function() {
  return {
    restrict: 'A',
    link: function ($scope, $element) {
      var navHeight = 51;

      var setSticky = function(){
        var windowTop = $(window).scrollTop(),
            elementTop = $element.offset().top,
            isHiddenByScroll = windowTop > (elementTop - navHeight);

        $scope.stickyFixed = isHiddenByScroll;
      };

      $(window).scroll(function () {
        setSticky();
        $scope.$digest();
      });

      setSticky();
    }
  }
});



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/stickyTopBlockDirective.js